var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudRaining05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-raining-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.6667 14.6458L11.875 16.625M6.33337 14.6458L5.54171 16.625M9.50004 14.6458L8.70837 16.625M5.54171 11.875C3.35558 11.875 1.58337 10.1028 1.58337 7.91668C1.58337 5.73055 3.35558 3.95834 5.54171 3.95834C5.56795 3.95834 5.59413 3.9586 5.62025 3.95911C6.34081 2.54886 7.80767 1.58334 9.50004 1.58334C11.4944 1.58334 13.1756 2.92423 13.6913 4.75367C13.7453 4.75124 13.7996 4.75001 13.8542 4.75001C15.8217 4.75001 17.4167 6.345 17.4167 8.31251C17.4167 10.28 15.8217 11.875 13.8542 11.875C10.8802 11.875 8.89458 11.875 5.54171 11.875Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudRaining05);
export default __webpack_public_path__ + "static/media/cloud-raining-05.c1ade4bcec011e59dae8756978ef1335.svg";
export { ForwardRef as ReactComponent };